<template>
  <div class="cq-header">
    <div class="behind-header">
      <h4> {{ headertext }} </h4><br>
    </div>
  </div>
</template>

<script>
export default {
  props: ['headertext']
}
</script>

<style>
.behind-header h4{
  font-family: 'Seravek-Bold';
  text-align: center;
  color: var(--secondary-color);
  width: 100%;
  background-color: var(--primary-color);
  padding: 12px;
  margin-top: 8px;
}

.behind-header{
  display: flex;
  align-items:center;
  justify-content: center;
  width: auto !important;
  min-width: 100%;
  margin: 35px 0 !important;
  background-image: linear-gradient(to right, var(--tertiary-color), var(--secondary-color), var(--tertiary-color)); /* Standard syntax (must be last) */
  position: relative;
}

@media only screen and (max-width: 992px){
  .behind-header h4{
    font-size: 19px !important;
  }
}
</style>
